
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightBulbOn as ObiLightBulbOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-bulb-on.js';
 
 
 

 
 export const ObiLightBulbOn = createComponent({
   react: React,
   tagName: 'obi-light-bulb-on',
   elementClass: ObiLightBulbOnElement,
   events: {
     
   }
  });
 
 